import { Routes } from '@angular/router';

import { itClimateSegments } from '@advania-cosoftware/wolf-router';

export const itClimateRoutes: Routes = [
    {
        path: itClimateSegments.itClimate,
        loadComponent: () => import('./pages/it-climate/it-climate.page').then((m) => m.ItClimatePage),
        data: {
            serviceId: 'SCM-1741610561-413',
        },
    },
];
